import { Component, Input } from '@angular/core';

@Component({
   selector: 'app-grid-column-component',
   template: ``
})
export class GridColumnComponent {

   private _component: any;

   factory: any;
   componentRef: any;
   componentInstance: any;

   constructor() { }

   @Input()
   set component(component: any) {
      this._component = component;
   }

   get component(): any {
      return this._component;
   }

}

